import { jingleCollectionCreate } from '@/entities/jingle-collections'
import { createEvent, createStore, sample } from 'effector'

export const lastCreatedJingleCollectionIdReset = createEvent()
export const $lastCreatedJingleCollectionId = createStore<string | null>(null)
  .on(jingleCollectionCreate.finished.success, (_, data) => data.result.id)
  .on(lastCreatedJingleCollectionIdReset, () => null)

sample({
  clock: jingleCollectionCreate.finished.success,
  target: [jingleCollectionCreate.reset],
})
